export default {
    key: 'joch',
    type: 'P2P',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: true,
    hideCrossSells: false,
    disablePassengers: false,
    isLoadingPassengerOffers: true,
    isRental: false,
    origins: [],
    destinations: [{
        ref: 'urn:uic:stn:8507364',
        name: 'Jungfraujoch – Top of Europe',
    }],
    returnOrigins: [],
    returnDestinations: [],
    isRoundtrip: true,
    canSwitchDirection: false,
    canChooseReturnDestination: false,
    isUsingReductionCards: true,
    isUsingKeyCards: false,
    hidePassengerMeasurements: false,
    isUsingPromos: true,
    isPromotionRequired: false,
    hasEPR: true,
    routeVariants: ['express', 'traditional-grin', 'traditional-laut'],
    routeVariantUp: 'default-jungfraujoch',
    routeVariantDown: 'default-jungfraujoch',
    upsells: [],
    isUsingSeasonDates: false,
    departureTimeIteration: 30,
    departureTimeDefaultMin: 420,
    stayDurationIteration: 30,
    stayDurationPopular: 120,
    stayDurationMin: 30,
    maxNumberOfPeople: 9,
    maxNumberOfPeopleGroupTariff: 10,
    salesTimeLimit: undefined,
    isUpsellDatesRestricted: true,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: 'urn:ts:listing:5d35d6ad-4495-4afe-a863-642f5e9f2cb0',
    contentfulId: 'joch',
    steps: [],

} satisfies ProductConfigP2P;
